import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import * as api from "../api/api";
import pca from "../index";

const checkAuthorization = async (pageName) => {
  try {
    const account = pca.getActiveAccount();

    //console.log("account: ", account);

    const tokenObject = await pca.acquireTokenSilent({
      account: pca.getActiveAccount(),
    });

    const token = tokenObject.idToken;
    //console.log(token);

    // const token = sessionStorage.getItem("token");
    const decodedToken = await jwtDecode(token);

    const response = await api.getUserRole(decodedToken.preferred_username);
    console.log(response.data.object.roles);

    // if user has one of their roles as 1 (super admin)

    const hasRole = response.data.object.roles.some((obj) => {
      return obj.roleId == 1;
    });
    if (hasRole) {
      return true;
    }

    const flattenedPermissions = [
      ...new Set(response.data.object.roles.flatMap((obj) => obj.permissions)),
    ];

    const availablePermissions = flattenedPermissions;

    const allowed = availablePermissions.some((item) => item.name === pageName);
    console.log(allowed);

    if (!allowed) {
      // unauthorized
      console.error("Unauthorized: Redirecting to /unauthorized");
      return false;
    } else {
      // authorized
      return true;
    }
  } catch (error) {
    // Handle errors during the authorization check
    console.error("Error checking authorization:", error);
    return false;
  }
};

export default checkAuthorization;
